module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "mtBoxGroup",
    staticClass: "mint-box-group",
    class: {
      'is-limit': _vm.isLimit
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5f6afe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/box-group/src/box-group.vue
// module id = 260
// module chunks = 0